module.exports = __webpack_public_path__ + "media/images/page/step_img04-789959c83f59f8a3eba3529a301b0ca1.svg";